/**
 * Compute floor(n / d) and store the remainder in r[0]
 */
export var floorDiv = function (n, d, r) {
    var q = Math.floor(n / d);
    r[0] = n % d;
    return q;
};
//# sourceMappingURL=util.js.map